// sync types
export const SET_SPEAKERS = 'sessions/SET_SPEAKERS';
